<template>
  <div :class="$style.wrapper" :key="numberOfTask">
    <div :class="$style.result" >
      <div ref="selected" :class="$style.selected" class="selected" data-container="result">
        <div :class="$style.placeholder" class="dropzone" v-for="(element, index) in placeholder" :key="element.name">
          <div :class="$style.placeholder__image" ></div>
          <button ref="remove" v-if="placeholder.length>1" :class="$style.placeholder__button" class="remove" @click="removePlaceholder(index)"></button>
        </div>
        <kinesis-container class="pointer button-container" v-if="showButtonAdd" >
          <kinesis-element :strength="12" type="depth">
            <button :class="$style.addButton" @click="addPlaceholder">
              <img :class="$style.addButton__image" src="../../assets/icons/plus.svg" />
            </button>
          </kinesis-element>
        </kinesis-container>
        <button v-if="showButtonAdd" :class="$style.addButton" @click="addPlaceholder" class="hide-on-desctop">
          <img :class="$style.addButton__image" src="../../assets/icons/plus.svg" />
        </button>
      </div>
    </div>
    <div ref="options" :class="$style.options" data-container="sourse">
      <div ref="dropzone" :class="$style.placeholder" class="dropzone draggable-dropzone--occupied" v-for="item in items" :key="item.description">
        <div :class="$style.placeholder__image"></div>
        <div :ref="item.type" class="item pointer" :class="$style.option" :data-type="item.type">
          <div :class="$style.option__wrapper">
            <div :class="$style.option__icon">
              <div :class="$style.image" :style="{ backgroundImage: `url(${require(`@/assets/icons/${item.icon}`)})` }"></div>
            </div>
            <span :class="$style.option__description">{{item.description}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Droppable } from '@shopify/draggable'

export default {
  name: 'DragAndDropTask',
  props: {
    numberOfTask: Number,
    taskUnlocked: Boolean,
  },
  data: () => ({
    info: [
      { type: 'message', icon: 'message.svg', description: 'Написать сообщение' },
      { type: 'videoCall', icon: 'videoCall.svg', description: 'Видеозвонок' },
      { type: 'audioCall', icon: 'audioCall.svg', description: 'Аудиозвонок' },
      { type: 'emoji', icon: 'emoji.svg', description: 'Отправить смайлик' },
      { type: 'location', icon: 'location.svg', description: 'Отправить местоположение в чат' },
      { type: 'photo', icon: 'photo.svg', description: 'Отправить фото в чат' },
      { type: 'videoChat', icon: 'videoChat.svg', description: 'Записать видеоклип' },
      { type: 'video', icon: 'clip.svg', description: 'Отправить видео в чат' },
      { type: 'sticker', icon: 'videoChat.svg', description: 'Отправить стикер' },
    ],
    options: [
      ['message', 'videoCall', 'audioCall', 'emoji'],
      ['location', 'message', 'audioCall', 'videoChat', 'videoCall'],
      ['photo', 'video', 'audioCall', 'sticker', 'videoCall'],
    ],
    resultList: [['audioCall'], ['location', 'message'], ['photo', 'video', 'videoCall']],
    placeholder: [],
    placeholderMaxCount: [1, 2, 3],
    nextPlaceholderId: 0,
  }),
  computed: {
    items() {
      const currentItems = []
      this.options[this.numberOfTask - 1].forEach((option) => {
        const index = this.info.findIndex(n => n.type === option)
        currentItems.push(this.info[index])
      })
      return currentItems
    },
    showButtonAdd() {
      return (this.placeholder.length !== this.placeholderMaxCount[this.numberOfTask - 1] && this.taskUnlocked)
    },
  },
  watch: {
    numberOfTask() {
      this.$nextTick().then(() => { this.reinitDroppable() })
    },
  },
  methods: {
    addPlaceholder() {
      if (this.placeholder.length === this.placeholderMaxCount[this.numberOfTask - 1]) return
      this.placeholder.push({ name: this.nextPlaceholderId })
      this.nextPlaceholderId += 1
    },
    removePlaceholder(index) {
      if (this.placeholder.length === 1) return
      this.placeholder.splice(index, 1)
    },
    refreshStatus() {
      if (!this.result.size) {
        this.$emit('help')
      } else if (this.checkCorrectResult()) {
        if (this.result.size === this.numberOfTask) this.$emit('success')
      } else this.$emit('warning', this.result)
    },
    checkCorrectResult() {
      let correct = true
      this.result.forEach((res) => {
        if (!this.checkCorrectItem(res)) correct = false
      })
      return correct
    },
    checkCorrectItem(item) {
      return this.resultList[this.numberOfTask - 1].includes(item)
    },
    initDroppable() {
      this.placeholder.length = 0
      this.addPlaceholder()
      this.result = new Set()
      this.droppable = new Droppable([this.$refs.options, this.$refs.selected], {
        draggable: '.item',
        dropzone: '.dropzone',
        delay: {
          mouse: 0,
          drag: 0,
          touch: 10,
        },
      })
      this.droppable.on('droppable:dropped', this.handleDropped)
      this.droppable.on('droppable:returned', this.handleReturned)
    },
    handleDropped(ev) {
      const optionType = ev.data.dragEvent.data.source.attributes.getNamedItem('data-type').value
      const sourceContainerEl = ev.data.dragEvent.data.sourceContainer
      const sourceContainerAttributes = sourceContainerEl.attributes.getNamedItem('data-container').value
      const targetEl = ev.data.dragEvent.data.sensorEvent.data.target
      const targetAttributes = targetEl.closest('[data-container]').attributes.getNamedItem('data-container')
      if (sourceContainerAttributes === 'result') {
        this.result.forEach((x) => {
          if (x === optionType) {
            const placeholder = sourceContainerEl.querySelector(`.wrong.${optionType}`)
            if (placeholder) placeholder.classList.remove('wrong', optionType)
            this.result.delete(x)
          }
        })
      }
      if (targetAttributes.value === 'result') {
        this.result.add(optionType)
        if (!this.checkCorrectItem(optionType)) {
          targetEl.closest('.dropzone').classList.add('wrong', optionType)
        }
      }
      this.refreshStatus()
    },
    handleReturned(ev) {
      const optionType = ev.data.dragEvent.data.source.attributes.getNamedItem('data-type').value
      const sourcePlaceholder = ev.data.dragEvent.data.originalSource
      const sourceContainer = sourcePlaceholder.closest('[data-container]').attributes.getNamedItem('data-container').value
      if (sourceContainer === 'result') {
        this.result.add(optionType)
        if (!this.checkCorrectItem(optionType)) {
          sourcePlaceholder.parentElement.classList.add('wrong', optionType)
        }
      } else {
        this.result.forEach((x) => {
          if (x === optionType) {
            ev.data.dropzone.classList.remove('wrong', optionType)
            this.result.delete(x)
          }
        })
      }
      this.refreshStatus()
    },
    reinitDroppable() {
      this.droppable.off('droppable:dropped', this.handleDropped)
      this.droppable.destroy()
      this.initDroppable()
    },
    hasResultValue(optionType) {
      let has = false
      this.result.forEach((x) => {
        if (x.type === optionType) has = true
      })
      return has
    },
  },
  mounted() {
    this.initDroppable()
  },
}
</script>

<style lang="scss" module>
  @import './DragAndDropTask.scss';
</style>
